import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchProducts = async () => {
  const res = await axios.get(`${API}/products`);
  return res.data;
};

export const fetchProduct = async (slug) => {
  const res = await axios.get(`${API}/products/${slug}`);
  return res.data;
};

export const createCheckout = async (payload) => {
  const res = await axios.post(`${API}/checkout/session`, payload);
  return res.data;
};

export const getCheckoutStatus = async (sessionId) => {
  const res = await axios.get(`${API}/checkout/status/${sessionId}`);
  return res.data;
};

export const subscribeNewsletter = async (email) => {
  const res = await axios.post(`${API}/newsletter`, { email });
  return res.data;
};

export const fetchAdminOrders = async () => {
  const token = localStorage.getItem("prestige_admin_token");
  const res = await axios.get(`${API}/admin/orders`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const adminLogin = async (email, password) => {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  return res.data;
};

export const adminMe = async (token) => {
  const res = await axios.get(`${API}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);

// ------ Customer (Emergent Google Auth) ------
export const exchangeSession = async (sessionId) => {
  const res = await axios.post(
    `${API}/auth/session`,
    { session_id: sessionId },
    { withCredentials: true },
  );
  return res.data;
};

export const fetchCustomerMe = async () => {
  const res = await axios.get(`${API}/auth/customer/me`, { withCredentials: true });
  return res.data;
};

export const logoutCustomer = async () => {
  const res = await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
  return res.data;
};

export const fetchAccountOrders = async () => {
  const res = await axios.get(`${API}/account/orders`, { withCredentials: true });
  return res.data;
};

export const openBillingPortal = async () => {
  const res = await axios.post(`${API}/account/portal`, {}, { withCredentials: true });
  return res.data;
};
